<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="title-heading d-flex justify-content-between">
          <h1>{{$static('chat.title', 'Сообщения')}}</h1>
        </div>
        <div class="chat-wrapper">
          <!-- <iframe src="http://localhost:6040/static/messenger" frameborder="0" width="100%"></iframe> -->
          <div class="chat-wrapper-holder">
            <div class="panel chat-panel chat-list-side">
              <div class="search-panel">
                <!--search panel-->
                <div class="search-group">
                  <input type="text" class="input-search form-control custom-input" placeholder="Найти">
                  <button class="search-btn">
                    <span class="icon icon-search"></span>
                  </button>
                </div>
                <!-- end search panel-->
              </div> 
              <div class="chat-list-tabs">
                <a href="#" class="list-tab-item active" >Все</a>
                <a href="#" class="list-tab-item">Открытые</a>
                <a href="#" class="list-tab-item">Закрытые</a>
              </div>
            </div>
            <div class="chat-body-side">
              <div class="panel chat-panel">
                <div class="chat-header">
                  <div class="text">
                    <span class="user-name">Alena Rhiel Madsen</span>
                    <span class="visit-time">был(а) 1 час назад</span>
                  </div>
                  <div class="actions ">
                    <div class="dropdown-toggle" id="chat_actions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                      <span class="icon icon-more-alt"></span>
                    </div>
                    <ul class="dropdown-menu custom-dropdown dropdown-menu-right" aria-labelledby="chat_actions">
                      <li>
                        <a href="#">
                          <span class="icon icon-user"></span>Посмотреть профайл
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <span class="icon icon-power"></span>Завершить чат
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="chat-holder">
                  <div class="chat-bottom">
                    <div class="form-group">
                      <a href="#" class="attach-btn">
                        <span class="icon icon-attach"></span>
                      </a>
                      <div class="button-holder">
                        <button class="chat-btn">
                          <span class="text">Отправить</span>
                          <span class="icon icon-telegram"></span>
                        </button>
                      </div>
                      <input type="text"  placeholder="Введите сообщение">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'Chat',
  }
</script>

<style scoped>

</style>